import { options_premium_AdditionalMailboxesText } from './CloudCacheOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
export let CloudCacheOption: LazyOption = createLazyOption(
    {
        key: 'cloudCacheAccount',
        titleStringKey: options_premium_AdditionalMailboxesText,
        searchTermsStringKey: options_premium_AdditionalMailboxesText,
        hideTitleInFullOptions: false,
        isHidden: () =>
            !isFeatureEnabled('auth-cloudCache') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox ||
            getUserConfiguration().IsConsumerChild,
    },
    lazyFullModule,
    m => m.default
);
export default CloudCacheOption;
